module.exports = __webpack_public_path__ + "static/media/valuechainanalyses.d050ff10.jpeg";